import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-bar-left', 'IconArrowBarLeft', [
  ['path', { d: 'M4 12l10 0', key: 'svg-0' }],
  ['path', { d: 'M4 12l4 4', key: 'svg-1' }],
  ['path', { d: 'M4 12l4 -4', key: 'svg-2' }],
  ['path', { d: 'M20 4l0 16', key: 'svg-3' }],
]);
